import { DASHBOARD_IDS, DASHBOARD_REGISTRY } from './report-dashboard-registry.js';
import { PMS_OPERATIONAL_REPORT_IDS, PMS_OPERATIONAL_REPORT_REGISTRY, } from './pms-operational-report-registry.js';
import { TRANSACTION_LIST } from '../operations/index.js';
function recentActivityFrom(template) {
    return {
        ...template,
        id: 'widget.organization.recentActivity',
        telemetryId: 'dashboard.widget.organization.recentActivity',
        accessibilityLabelKey: 'dashboard.widgets.recentActivity',
        titleKey: 'dashboard.widgets.recentActivity',
        dataSourceId: 'query.dashboard.recentActivity',
        position: { x: 0, y: 12, w: 12, h: 4 },
        widgetType: 'table',
        drilldownOperationId: TRANSACTION_LIST,
        tableId: 'table.dashboard.recentActivity',
    };
}
function allocationFrom(template) {
    const report = PMS_OPERATIONAL_REPORT_REGISTRY[PMS_OPERATIONAL_REPORT_IDS.ALLOCATION_EXPOSURE];
    const visualization = report.visualizations?.[0];
    if (!visualization) {
        throw new Error(`Report ${report.id} has no governed allocation visualization`);
    }
    const { tableId: _tableId, ...chartTemplate } = template;
    return {
        ...chartTemplate,
        id: 'widget.organization.allocationExposure',
        module: report.module,
        feature: report.feature,
        operationId: report.operationId,
        privacyClassification: report.privacyClassification,
        telemetryId: 'dashboard.widget.organization.allocationExposure',
        accessibilityLabelKey: visualization.titleKey,
        titleKey: visualization.titleKey,
        dataSourceId: report.dataSourceId,
        position: { x: 0, y: 8, w: 6, h: 4 },
        widgetType: 'chart',
        drilldownOperationId: String(report.operationId),
        visualization,
    };
}
/**
 * A managed-account client should not receive the internal investment-accounting
 * metric grid (cost basis, realized/unrealized split, return-on-cost). The
 * consumer headline is projected through `homeSummary`; the descriptor retains
 * only the holdings detail surface so deeper information remains available on
 * demand without competing with the simple portfolio story.
 */
function clientPortfolioDashboard(base) {
    const nonMetrics = base.widgets.filter((widget) => widget.widgetType !== 'metric');
    return Object.freeze({
        ...base,
        widgets: nonMetrics.map((widget) => ({
            ...widget,
            position: { ...widget.position, y: 0 },
        })),
    });
}
/**
 * Organization Home intentionally has one financial headline hierarchy. The
 * four authoritative headline values (market value, total P&L, period return,
 * and cash) are rendered from `homeSummary`; the descriptor below therefore
 * contains operational/data-quality widgets, the governed allocation view,
 * holdings, and recent activity.
 */
function organizationPortfolioDashboard(base) {
    const tableTemplate = base.widgets.find((widget) => widget.widgetType === 'table');
    if (!tableTemplate)
        throw new Error(`Dashboard ${base.id} has no table template`);
    const nonMetrics = base.widgets.filter((widget) => widget.widgetType !== 'metric');
    return Object.freeze({
        ...base,
        widgets: [
            ...nonMetrics,
            allocationFrom(tableTemplate),
            recentActivityFrom(tableTemplate),
        ],
    });
}
export const EFFECTIVE_DASHBOARD_REGISTRY = Object.freeze({
    ...DASHBOARD_REGISTRY,
    [DASHBOARD_IDS.ORGANIZATION]: organizationPortfolioDashboard(DASHBOARD_REGISTRY[DASHBOARD_IDS.ORGANIZATION]),
    [DASHBOARD_IDS.CLIENT]: clientPortfolioDashboard(DASHBOARD_REGISTRY[DASHBOARD_IDS.CLIENT]),
});
